module.exports = __webpack_public_path__ + "static/media/ploni-medium-aaa.d81a151f.woff2";